module.exports = __webpack_public_path__ + "media/headerBg.10b58745.mp4";